import React from "react";

const SearchResultsGroup = ({ title, items, parentKey, afterKey }) => {
    return (
        <div className="search__group">
            <div className="search__title">{title}</div>
            <div className="search__cats">
                {items.map((item) => {
                    return (
                        <a key={item.id} href={item.link}>
                            {parentKey && item[parentKey] ? (
                                <>
                                    <span>{item[parentKey]}</span> <i>▷</i>
                                </>
                            ) : null}

                            {item.name}

                            {afterKey && item[afterKey] ? (
                                <span> - {item[afterKey]}</span>
                            ) : null}
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default SearchResultsGroup;
